module.exports = __webpack_public_path__ + "img/5.00bcc13e.png";